class TermsAndConditions extends HTMLElement {
    constructor() {
        super();      
      	this.Binds();
    }
  
    Binds () {
      var self = this;
      this.parentNode.querySelector('.cart__checkout-button.button').addEventListener("click", function (event) {
        if (!this.parentNode.querySelector('#enable_terms').checked) {
          event.preventDefault(); 
          
          var container = this.parentNode.querySelector('#enable_terms').parentNode.parentNode;
          
          if (container.querySelector('.error') == null) {
            var error = document.createElement('p');
            error.classList.add('error');
            error.innerHTML = "Dette felt er påkrævet";
            container.appendChild(error);
            
            if (!self.is_terms_bound) {
              this.parentNode.querySelector('#enable_terms').addEventListener('change', function () {
                if (container.querySelector('.error')) {
                  container.querySelector('.error').parentNode.removeChild(container.querySelector('.error'));
                }
              }, true);
              self.is_terms_bound = true;
            }
          }
        } 
      });
    }
}

customElements.define("terms-and-conditions", TermsAndConditions);

class TermsAndConditionsDrawer extends HTMLElement {
    constructor() {
        super();      
      	this.Binds();
    }
  
    Binds () {
      var self = this;
      this.parentNode.querySelector('.button-container .button.temp').addEventListener("click", function (event) {
        console.log(this)
        if (!this.parentNode.parentNode.querySelector('#enable_terms').checked) {
          event.preventDefault(); 
          
          var container = this.parentNode.parentNode.querySelector('#enable_terms').parentNode;
          
          if (container.querySelector('.error') == null) {
            var error = document.createElement('p');
            error.classList.add('error');
            error.innerHTML = "Dette felt er påkrævet";
            container.appendChild(error);
            
            if (!self.is_terms_bound) {
              this.parentNode.parentNode.querySelector('#enable_terms').addEventListener('change', function () {
                if (container.querySelector('.error')) {
                  container.querySelector('.error').parentNode.removeChild(container.querySelector('.error'));
                }
              }, true);
              self.is_terms_bound = true;
            }
          }
        }
       else {
         document.querySelector(".button.submitCheckout").click()
       }
        
        
      });
    }
}

customElements.define("terms-and-conditiondrawer", TermsAndConditionsDrawer);

/* ---------------------------------------------------------------------------
   External menu and footer links open in a new tab.
   Any link pointing at another hostname gets target=_blank plus
   rel="noreferrer noopener" (noopener matters: without it the opened page can
   reach back through window.opener).
   Runs on every page — this file is deferred on all layouts.

   Three selectors are needed, not just .list-menu:
     .list-menu a          header and drawer menus
     a.list-menu__item     footer link lists, whose list element is
                           `footer-block__details-content list-unstyled` and has
                           no .list-menu container at all — the class only lands
                           on the anchor
     .footer a             everything else in the footer: social icons, policy
                           links, contact details

   Note: iteration deliberately avoids less-than comparisons against array
   length. This is a .liquid asset, so Shopify's Liquid/HTML parser treats a
   less-than sign followed by a letter as the start of an HTML tag and reports
   a syntax error.
--------------------------------------------------------------------------- */
(function () {
  var SELECTOR = '.list-menu a[href], a.list-menu__item[href], .footer a[href]';

  function externalize(link) {
    // Skip in-page anchors, mailto:, tel: and other non-web schemes — those
    // have no meaningful hostname and must not be forced into a new tab.
    if (link.protocol !== 'http:' && link.protocol !== 'https:') return;
    if (link.hostname === window.location.hostname) return;

    link.target = '_blank';
    link.rel = 'noreferrer noopener';
  }

  function externalizeMenuLinks(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;

    // A node injected by an app can itself be a matching link, not just a
    // container of one.
    if (scope.matches && scope.matches(SELECTOR)) externalize(scope);

    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), externalize);
  }

  function run() {
    externalizeMenuLinks(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // The drawer, mega-menu and predictive search can inject markup after load,
  // so re-run on newly added nodes rather than only once.
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) externalizeMenuLinks(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
